import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;
const CONSENT_KEY = "sf-cookie-consent";

function loadGA() {
  if (!GA_ID || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

export default function GoogleAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!GA_ID) return undefined;
    const maybeLoad = () => {
      if (localStorage.getItem(CONSENT_KEY) !== "all") return;
      const wasLoaded = window.__gaLoaded;
      loadGA();
      if (!wasLoaded && window.__gaLoaded && window.gtag) {
        const path = window.location.pathname;
        if (!path.startsWith("/admin") && !path.startsWith("/login")) {
          setTimeout(() => {
            window.gtag("event", "page_view", { page_path: window.location.pathname, page_title: document.title });
          }, 0);
        }
      }
    };
    maybeLoad();
    window.addEventListener("cookie-consent-changed", maybeLoad);
    return () => window.removeEventListener("cookie-consent-changed", maybeLoad);
  }, []);

  useEffect(() => {
    if (!GA_ID || !window.__gaLoaded || !window.gtag) return;
    if (pathname.startsWith("/admin") || pathname.startsWith("/login")) return;
    // rinvia al task successivo: gli effetti delle pagine (document.title) girano dopo questo componente
    const t = setTimeout(() => {
      window.gtag("event", "page_view", { page_path: window.location.pathname, page_title: document.title });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
